<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-container>
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Customizations</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn class="ml-3" color="accent" :loading="waiting" :disabled="waiting" @click="save">
                        <v-icon style="color: #000000;" left>mdi-content-save</v-icon>
                        <span style="color: #000000;">Save</span>
                    </v-btn>
                    <v-spacer/>
                    <v-btn class="mr-3" color="accent" :loading="waiting" :disabled="waiting" @click="save">
                        <v-icon style="color: #000000;" left>mdi-content-save</v-icon>
                        <span style="color: #000000;">Save</span>
                    </v-btn>
                </v-card-actions>
                <v-card-text>
                    <RecordingSettings/>
                    <ConstrictResultFields/>
                    <v-container py-3 px-0>
                        <FullSpectrumResultFields/>
                    </v-container>
                    <NoLightResultFields/>
                </v-card-text>
                <v-card-text>
                    <ConcussionSettings/>
                    <ExportType/>
                    <OperationalMode v-if="currentUser.isProUser"/>
                    <UnitsOfMeasure v-if="currentUser.isProUser"/>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="ml-3 mb-5" color="accent" :loading="waiting" :disabled="waiting" @click="save">
                        <v-icon style="color: #000000;" left>mdi-content-save</v-icon>
                        <span style="color: #000000;">Save</span>
                    </v-btn>
                    <v-spacer/>
                    <v-btn class="mr-3 mb-5" color="accent" :loading="waiting" :disabled="waiting" @click="save">
                        <v-icon style="color: #000000;" left>mdi-content-save</v-icon>
                        <span style="color: #000000;">Save</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import RecordingSettings from '@/components/recording-settings'
    import ConstrictResultFields from '@/components/constrict-result-fields'
    import FullSpectrumResultFields from '@/components/full-spectrum-result-fields'
    import NoLightResultFields from '@/components/no-light-result-fields'
    import ExportType from '@/components/export-type'
    import OperationalMode from '@/components/operational-mode'
    import UnitsOfMeasure from '@/components/units-of-measure'
    import ConcussionSettings from '@/components/concussion-settings'

    export default
    {
        name: 'user-customization-tab',
        components:
        {
            RecordingSettings,
            ConstrictResultFields,
            FullSpectrumResultFields,
            NoLightResultFields,
            ExportType,
            OperationalMode,
            UnitsOfMeasure,
            ConcussionSettings
        },
        data: function ()
        {
            return {
            }
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser ? state.currentUser : {},
                currentUserChanges: state => state.currentUserChanges ? state.currentUserChanges : {}
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        beforeDestroy()
        {
            this.SET_CURRENT_USER(this.currentUser)
        },
        methods:
        {
            ...mapActions('auth', ['UPDATE_CURRENT_USER']),
            ...mapMutations('auth', ['SET_CURRENT_USER']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'SHOW_SNACKBAR_SUCCESS', 'HIDE_SNACKBAR']),
            async save()
            {
                this.$logEvent(this.$firebaseAnalytics, 'screen_view',
                {
                    app_name: 'Web Portal',
                    screen_name: `Reflex Web Portal - ${this.$options.name}`,
                    app_version: process.env.VUE_APP_VERSION
                });
                // Make sure the video duration is not shorter than the torch duration
                if (this.currentUserChanges.preferences.videoDuration < this.currentUserChanges.preferences.torchDuration)
                {
                    this.currentUserChanges.preferences.torchDuration = this.currentUserChanges.preferences.videoDuration
                }
                // Make sure that the illumination delay does not cause the video duration to go beyond 15 seconds
                if (this.currentUserChanges.preferences.illuminationDelay + this.currentUserChanges.preferences.videoDuration > 15)
                {
                    this.currentUserChanges.preferences.illuminationDelay = 15 - this.currentUserChanges.preferences.videoDuration
                }
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.UPDATE_CURRENT_USER(this.currentUserChanges);
                    this.SHOW_SNACKBAR_SUCCESS('User profile updated.')
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            }
        }
    };
</script>

<style scoped>
</style>